
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { TERMS_OF_SERVICE } from '@/data/termsOfService';

interface TermsOfServiceModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({
  open,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-hidden">
        <DialogHeader>
          <DialogTitle className="text-2xl font-poppins-bold">Felhasználási Feltételek</DialogTitle>
          <DialogDescription>
            Kérjük, figyelmesen olvassa el a felhasználási feltételeket
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <div className="font-poppins-regular">
            {TERMS_OF_SERVICE.sections.map((section, index) => (
              <section key={index} className="mb-6">
                <h2 className="text-xl font-poppins-semibold mb-4">{section.title}</h2>
                <p className="text-gray-700 mb-4">{section.content}</p>
              </section>
            ))}
            <div className="mt-8 text-sm text-gray-500">
              <p>Utolsó frissítés: {TERMS_OF_SERVICE.lastUpdated}</p>
            </div>
          </div>
        </ScrollArea>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Bezárás
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TermsOfServiceModal;
